import { useAppSelector } from "../store/hooks";
import { selectAppTheme } from "../store/selectors/appSelectors";

/**
 * Hook with the common top level app logic
 */
const useApp = () => {
  const theme = useAppSelector(selectAppTheme);

  return {
    theme,
  };
};

export default useApp;
